// extracted by mini-css-extract-plugin
export default {"num":"styles_num__sw00D"};